<script lang="ts">
import { defineComponent } from 'vue';
import { any } from 'vue-types';

export default defineComponent({
  name: 'Section',
  props: {
    class: any(),
  },
});
</script>

<template>
  <div :class="['min-w-0 max-w-full bg-white p-4 dark:bg-gray-900', $props.class]">
    <slot />
  </div>
</template>
